import { SelectOption } from '../globalTypes'

export const formatExportServiceOptions = (items?: { id: number; title: string }[]): SelectOption[] =>
    items?.map((item) => ({ value: item.id.toString(), label: item.title })) ?? []
